
export const OverlayGrayBackground = ({
  testId,
  additionalClass
}) => {
    return (
      <div className={`absolute w-full h-full bg-slate-200 z-30 opacity-70 ${additionalClass}`} data-testid={testId}></div>
    )
}